import { FilledTextFieldProps, TextField } from '@mui/material';
import {
  Controller,
  UseControllerProps,
  useFormContext,
} from 'react-hook-form';

import OptionalLabel from 'components/@forms/OptionalLabel';

type Props = Pick<UseControllerProps, 'rules' | 'name'> &
  Omit<FilledTextFieldProps, 'variant' | 'name'>;

const FormTextField = ({
  rules,
  name,
  label,
  helperText,
  error,
  ...rest
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({
        field: { ref, ...field },
        fieldState: { error: ruleError },
      }) => {
        return (
          <TextField
            label={<OptionalLabel label={label} required={rules?.required} />}
            fullWidth
            {...field}
            inputRef={ref}
            error={!!error || !!ruleError}
            helperText={ruleError?.message ?? helperText}
            {...rest}
          />
        );
      }}
    />
  );
};

export default FormTextField;
